import { createFileRoute } from '@tanstack/react-router';
import { AiOpsCostPage } from '@/pages/super-admin/ai-ops/AiOpsCostPage';
import { aiOpsWindowSearchSchema } from '@/pages/super-admin/ai-ops/ai-ops.constants';

export const Route = createFileRoute('/_authenticated/super-admin/ai-ops/cost')({
	component: AiOpsCostPage,
	validateSearch: aiOpsWindowSearchSchema,
});
